import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { DialogDeciderActionTypes } from "../ActionSelectorDialog";

export const ActionButtonRenderer: React.FC<{
  id: string;
  dialogAction: DialogDeciderActionTypes;
}> = ({ children, id, dialogAction: { action } }) => {
  const { push } = useHistory();
  let ButtonRendered;
  switch (action) {
    case "PE":
      ButtonRendered = (
        <Button
          color="primary"
          onClick={() => push(`/public-enquiries/list/${id}`)}
          data-test="navigate-to-pe"
        >
          {children}
        </Button>
      );
      break;
    case "Complaint":
      ButtonRendered = (
        <Button
          color="primary"
          onClick={() => push(`/complaints/${id}`)}
          data-test="navigate-to-complaint"
        >
          {children}
        </Button>
      );
      break;
    default:
      return null;
  }

  return ButtonRendered;
};
